import React, {useState, useEffect, Fragment} from 'react'
import { useTranslation } from 'react-i18next';
import parse from 'html-react-parser';

const Price = ({value}) => {
    const [data, setData] = useState(null);
    const { t } = useTranslation();

    useEffect(() => {
        if(value.toString().indexOf('.') > 0){
            var priceArray = value.toString().split('.');
            setData({number: priceArray[0], decimal: priceArray[1]});
        }else{
            setData({number: value, decimal:'00'});
        }
    }, [value])
    
    return (
        <Fragment>
            {data && 
                <h4 className="amount">{parse(t('price_format', {price: data.number, decimal:data.decimal}))}</h4>
            }
        </Fragment>
    )
}

export default Price
